export default "__VITE_ASSET__CZKcCeRr__"